(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@aws-amplify/pubsub"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_datastore", ["@aws-amplify/pubsub"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_datastore"] = factory(require("@aws-amplify/pubsub"));
	else
		root["aws_amplify_datastore"] = factory(root["@aws-amplify/pubsub"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__23__) {
return 